import React from 'react';
import Button from './Button';
import Card from './Card';

interface DeleteProgrammeModalProps {
  programmeName: string;
  projectCount: number;
  onConfirm: () => void;
  onCancel: () => void;
}

const DeleteProgrammeModal: React.FC<DeleteProgrammeModalProps> = ({
  programmeName,
  projectCount,
  onConfirm,
  onCancel,
}) => {
  return (
    <div className="modal-backdrop">
      <div className="modal-content" style={{ maxWidth: '500px' }}>
        <Card variant="elevated">
          <Card.Header title="Confirm Programme Deletion" />
          <Card.Body>
            <div className="mb-4">
              <p className="text-lg font-semibold mb-2" style={{ color: 'var(--error)' }}>
                Are you sure you want to delete "{programmeName}"?
              </p>
              
              {projectCount > 0 ? (
                <div className="bg-amber-50 border border-amber-200 rounded p-3 mb-3">
                  <p className="text-sm text-amber-900">
                    <strong>⚠️ Warning:</strong> This programme has <strong>{projectCount}</strong> {projectCount === 1 ? 'project' : 'projects'} assigned.
                  </p>
                  <p className="text-sm text-amber-800 mt-2">
                    All projects will be <strong>unassigned</strong> from this programme but will remain in the system.
                  </p>
                </div>
              ) : (
                <p className="text-sm text-gray-600 mb-3">
                  This programme has no projects assigned. It can be safely deleted.
                </p>
              )}
              
              <p className="text-sm text-gray-700">
                This action cannot be undone.
              </p>
            </div>
          </Card.Body>
          <Card.Footer>
            <Button onClick={onCancel} variant="outline">
              Cancel
            </Button>
            <Button onClick={onConfirm} variant="danger">
              Delete Programme
            </Button>
          </Card.Footer>
        </Card>
      </div>
    </div>
  );
};

export default DeleteProgrammeModal;
